import { Search } from "react-bootstrap-icons";

const TopbarSearch = () => (
  <form className="topbar__search">
    <input placeholder="Search..." className="topbar__search-field" />
    <button
      className="topbar__btn topbar__search-btn"
      type="button"
      aria-label="topbar search button"
    >
      <Search />
    </button>
  </form>
);

export default TopbarSearch;
